var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRtnLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m42,73l12.07-48h20.13c9.45,0,15.45,6.03,15.45,13.92,0,7.41-5.17,13.58-13.1,16.18l5.17,17.9h-13.79l-4.21-16.59h-4.55l-4.21,16.59h-12.96Zm19.72-26.74h7.58c4.14,0,7.1-3.09,7.1-6.65,0-2.61-1.79-4.32-4.21-4.32h-7.72l-2.76,10.97Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m94.58,73l9.31-37.03h-12.76l2.76-10.97h38.61l-2.76,10.97h-12.76l-9.31,37.03h-13.1Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m123.58,73l12-48h12.55l10.27,28.11,6.69-28.11h12.76l-12,48h-12.55l-10.34-28.11-6.55,28.11h-12.83Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m218,48c0,5.96-2.76,11.8-8.08,17.29-5.33,5.5-13.14,10.54-22.94,14.82-19.6,8.55-46.81,13.89-76.98,13.89s-57.38-5.34-76.98-13.89c-9.8-4.28-17.61-9.32-22.94-14.82-5.32-5.49-8.08-11.33-8.08-17.29s2.76-11.8,8.08-17.29c5.33-5.5,13.14-10.54,22.94-14.82C52.62,7.34,79.83,2,110,2s57.38,5.34,76.98,13.89c9.8,4.28,17.61,9.32,22.94,14.82,5.32,5.49,8.08,11.33,8.08,17.29Z",
    stroke: "currentColor",
    style: {
      fill: "none",
      strokeWidth: 4
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtnLogo);
export default __webpack_public_path__ + "static/media/rtn-logo.547ecdab950d00d897e14b3ab473cd70.svg";
export { ForwardRef as ReactComponent };